import {IconButton, Link, Menu, TableCell, TableRow} from "@mui/material";
import React, {useState} from "react";
import moment from "moment-timezone";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {ChatdeskUpdatesActions} from "./Actions";
import styles from "./Styles.module.css";
import BasicTooltip from "../v2/common/BasicTooltip";

export const ChatdeskUpdatesRow = ({update}) => {
    const {
        summary,
        isActive,
        dateCreated,
        organization: {name},
        creator: {username},
        googleDocsLink
    } = update

    const statusText = isActive ? "Enabled" : "Disabled"
    const zone_name =  moment.tz.guess();
    const timezone = moment.tz(zone_name).zoneAbbr();
    const link = <Link href={googleDocsLink} target="_blank">View In Google Doc</Link>

    const [anchorElement, setAnchorElement] = useState(undefined)
    const handleClick = (event) => setAnchorElement(event.currentTarget)
    const handleClose = () => setAnchorElement(undefined)
    const open = Boolean(anchorElement);

    return (
        <TableRow className={styles.tableRow}>
            <TableCell className={styles.tableCell} >
                <span className={styles.typography13}>
                    <span>{name}</span>
                </span>
            </TableCell>

            <TableCell className={styles.tableCell}>
                <span className={styles.typography13}>
                    <span>
                      {`${moment(dateCreated).format('MMM DD hh:mm A z ')} ${timezone}`}
                    </span>
                </span>
            </TableCell>

            <TableCell className={styles.tableCell}>
                <span className={styles.typography13}>
                    <span>{username}</span>
                </span>
            </TableCell>

            <BasicTooltip
                title={summary}
                placement={'bottom'}
                enterDelay={700}
            >
                <TableCell className={styles.tableCell}>
                    <span className={styles.typography13}>
                        <span>{summary}</span>
                    </span>
                </TableCell>
            </BasicTooltip>

            <TableCell className={styles.tableCell}>
                <span className={styles.typography13}>
                    <span>{statusText}</span>
                </span>
            </TableCell>

            <TableCell className={styles.tableCell}>
                <span className={styles.typography13}>
                    <span>{googleDocsLink ? link : 'No Link available'}</span>
                </span>
            </TableCell>

            <TableCell className={styles.tableCell}>
                <IconButton
                    aria-label="More"
                    aria-owns={open ? 'long-menu' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon size="small"/>
                </IconButton>

                    <Menu
                        id="long-menu"
                        anchorEl={anchorElement}
                        open={open}
                        onClose={handleClose}
                    >
                        <ChatdeskUpdatesActions
                            update={update}
                        />

                    </Menu>
            </TableCell>

        </TableRow>
    )
}